export const formatDate = ({ date, formatDateInl }) => {
  return formatDateInl(date, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}
